import "./Channel.scss";

import { Box, TablePagination } from "@mui/material";
import React, { useEffect, useState } from "react";

import ChannelCard from "../molecules/Channels/ChannelCard";
import RelevanceSidebar from "../molecules/Channels/RelevanceSidebar";
import { relevanceScoreData } from "../utils/data";

interface ChannelsProps {
  handleCardClick: (title: string, channelName: string) => void;
  channelToggleOption: string;
  cardData: any[];
}

const Channels: React.FC<ChannelsProps> = ({
  handleCardClick,
  cardData,
  channelToggleOption,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [activeId, setActiveId] = useState<number | null>(null);
  const [relevanceData, setRelevanceData] = useState(relevanceScoreData);

  useEffect(() => {
    // Update relevanceData scores from cardData
    const updatedRelevance = relevanceScoreData.map((platform) => {
      const match = cardData.find(
        (card) =>
          card.channelName &&
          card.channelName.toLowerCase() === platform.name.toLowerCase()
      );
      return {
        ...platform,
        score:
          match?.channelRelevance != null
            ? Math.round(Number(match.channelRelevance) * 100)
            : platform.score,
      };
    });
    setRelevanceData(updatedRelevance);
  }, [cardData]);

  const handleActiveClick = (id: number) => {
    setActiveId(id);
    setPage(0);
  };

  const handleChangeRowsPerPage = (event: any) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event: any, newPage: number) => {
    setPage(newPage);
  };

  // Get selected platform from sidebar
  const selectedPlatform = relevanceData.find(
    (item) => item.id === activeId
  )?.name;

  // Filter cardData by selected platform (from sidebar)
  let filteredData = selectedPlatform
    ? cardData.filter(
        (item) =>
          item.channelName &&
          item.channelName.toLowerCase() === selectedPlatform.toLowerCase()
      )
    : [...cardData]; // clone if no platform is selected

  // Further filter based on campaignRelevance and toggle option
  filteredData =
    channelToggleOption.toLowerCase() === "all"
      ? filteredData
      : filteredData.filter((item) => {
          return (
            item.clusterRelevanceLevel.toLowerCase() ===
            channelToggleOption.toLowerCase()
          );
        });

  const paginatedCardData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <Box
      display="flex"
      className="main"
      sx={{ height: "calc(100svh - 18rem)", paddingBottom: 0 }}
    >
      <RelevanceSidebar
        relevanceScoreData={relevanceData}
        handleActiveClick={handleActiveClick}
        activeId={activeId}
      />

      <Box sx={{ height: "100%", width: "2px", bgcolor: "#0000000F" }} mx={2} />

      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            maxHeight: "calc(100svh - 22rem)",
            bgcolor: "#f3f6f8",
             display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 1.5,
            overflow: "auto",
          }}
        >
          {paginatedCardData.map((item, idx) => (
            <ChannelCard
              key={idx}
              id={`${item.channelName}-${idx}`}
              handleCardClick={() =>
                handleCardClick(item.campaignName, item.channelName)
              }
              title={item.title}
              relevance={item.clusterRelevance}
              keywordClusters={item.relatedKeywords?.length || 0}
            />
          ))}
        </Box>

        <TablePagination
          rowsPerPageOptions={[6, 12, 18]}
          component="div"
          count={filteredData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Box>
    </Box>
  );
};

export default Channels;
